import { render } from "./CarrierScan.vue?vue&type=template&id=20544994"
import script from "./CarrierScan.vue?vue&type=script&lang=js"
export * from "./CarrierScan.vue?vue&type=script&lang=js"
script.render = render

export default script